export const baseSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    minHeight: '32px',
    height: '32px',
    fontSize: '13px',
    padding: '0 4px',
    borderColor: state.isFocused ? '#38AD3E' : '#ccc',
    boxShadow: 'none',
    cursor: 'pointer',
  }),

  option: (provided, state) => ({
    ...provided,
    fontSize: '13px',
    backgroundColor: state.isFocused
      ? '#93f4adff'
      : state.isSelected
      ? '#38AD3E'
      : 'white',
    color: state.isSelected ? '#fff' : '#333333',
    cursor: 'pointer',
    ':active': {
      backgroundColor: state.isSelected ? '#2E7D32' : '#38AD3E',
      color: '#333333',
    },
  }),

  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 2,
    color: '#38AD3E',
  }),

  indicatorSeparator: () => ({ display: 'none' }),

  singleValue: (provided) => ({
    ...provided,
    color: '#2E7D32',
  }),
};


